<template>
  <div class="gradeCertificateDelivery">
    <h3>
      申请证书证章
      <el-button class="goBack" @click="back" type="danger" plain>返 回</el-button>
    </h3>
    <!-- <p>申请须知:首次申请{{userRole==1?'运动员':'考评员'}}证书证章，仅需支付快递费用。</p> -->
    <!-- <p>{{userRole==1?'申请须知:首次申请运动员证书证章，仅需支付快递费用。':''}}</p> -->
	<p style="height: 21px;"></p>
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="收件人" prop="contacts">
            <el-input type="text" v-model="ruleForm.contacts"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="申请类型" :error="error" :required="true">
            <el-cascader
              v-model="appType"
              autocomplete="off"
              :options="options"
              style="width:100%"
              :props="{ multiple: true }"
              @change="cascader"
              class="cascader"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="手机号码" prop="telphone">
            <el-input type="text" v-model="ruleForm.telphone" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="邮寄地址" required>
            <el-row :gutter="10" style="width:100%;margin-left:0px;">
              <el-col :xs="8" :sm="8" :md="8" style="padding-left:0px;">
                <el-form-item prop="province">
                  <el-select
                    v-model="ruleForm.province"
                    placeholder="请选择省"
                    style="width:100%"
                    @change="chooseProvince($event)"
                  >
                    <el-option
                      v-for="item in province"
                      :key="item.id"
                      :label="item.area_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="8" :sm="8" :md="8">
                <el-form-item prop="city">
                  <el-select
                    v-model="ruleForm.city"
                    placeholder="请选择市"
                    style="width:100%"
                    @change="chooseCity($event)"
                  >
                    <el-option
                      v-for="item in city"
                      :key="item.id"
                      :label="item.area_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="8" :sm="8" :md="8" style="padding-right:0px;">
                <el-form-item prop="district">
                  <el-select
                    v-model="ruleForm.district"
                    placeholder="请选择地区"
                    style="width:100%"
                    @change="chooseDistrict($event)"
                  >
                    <el-option
                      v-for="item in district"
                      :key="item.id"
                      :label="item.area_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="详细地址" prop="mailing_detail_address">
            <el-input type="text" v-model="ruleForm.mailing_detail_address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <div style="text-align:center;margin:20px 0px">
            <label>证书费：</label>
            <span style="color:#ea0000;">{{fee.certificateFee}}元</span> 
            <label style="padding-left:10px;">证章费：</label>
            <span style="color:#ea0000;">{{fee.badgesFee}}元</span>
            <label style="padding-left:10px;">快递费：</label>
            <span style="color:#ea0000;">{{fee.fee}}元</span>
          </div>
          <div style="text-align:right;margin:20px 0px">
            <label style="padding-left:10px;">总计：</label>
            <span style="color:#ea0000;">{{count}}元</span>
          </div>
        </el-col>

        <div class="submit">
          <!-- <el-button type="danger" @click="back" style="width:70px;height:40px">返回</el-button> -->
          <el-button type="danger" @click="submitForm('ruleForm')" :loading="loading">提 交</el-button>
        </div>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  GetPaperCertificate,
  GetPersonalCertificate,
  GetGradeList
} from "@/api/admin/appraiser.js";
import { GetDistrictList, GetDicData , Getexpressfee } from "@/api/admin/common.js";
import { isMobile } from "@/util/validate.js";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["userRole"])
  },
  data() {
    //验证用户名
    var checkcontacts = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    //验证申请类型
    // var checkappType = (rule, value, callback) => {
    //    if (!value) {
    //       return callback(new Error("申请类型不能为空"));
    //    }
    // };
    //验证手机号
    var checkTel = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入联系方式"));
      } else {
        if (isMobile(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的电话"));
        }
      }
    };
    //验证省市区
    var checkProvince = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("省不能为空"));
      } else {
        callback();
      }
    };
    var checkCity = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("市不能为空"));
      } else {
        callback();
      }
    };
    var checkArea = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("区不能为空"));
      } else {
        callback();
      }
    };
    //详细地址
    var checkaddressDetail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("详细地址不能为空"));
      } else {
        callback();
      }
    };
    return {
      province: [],
      city: [],
      district: [],
      ruleForm: {
        certificate: []
      },
      rules: {
        contacts: [
          { required: true, validator: checkcontacts, trigger: "blur" }
        ],
        telphone: [{ required: true, validator: checkTel, trigger: "blur" }],
        province: [
          { required: true, validator: checkProvince, trigger: "blur" }
        ],
        city: [{ required: true, validator: checkCity, trigger: "blur" }],
        district: [{ required: true, validator: checkArea, trigger: "blur" }],
        mailing_detail_address: [
          {
            required: true,
            validator: checkaddressDetail,
            trigger: "blur"
          }
        ]
      },
      options: [],
      imgUrl: {},
      certificate_grade: [],
      appType: [],
      error: "",
      loading: false,
      fee: {
        certificateFee: 0,
        badgesFee: 0,
        fee: 0
      },
      count: 0,
      list: []
    };
  },

  created() {
    this.getList();
  },
  watch: {
    "ruleForm.province"(val) {
      GetDistrictList({ parent_id: val }).then(data => {
        this.city = data.data.result.items;
        this.ruleForm.city = this.city[0].id;
        this.chooseCity(this.ruleForm.city);
      });
    }
  },
  methods: {
    getList() {
      GetPersonalCertificate({}).then(data => {
        
        let list = data.data.result;
        if (list.items.length > 0) {
          this.imgUrl = list.items[0];
        }
      }),
        GetDistrictList({ parent_id: "-1" }).then(data => {
          if (data.data.result) {
            this.province = data.data.result.items;
          }
        });

      GetDicData({ classCode: "certificate_grade" }).then(dicdata => {
        if (dicdata.data.result) {
          this.certificate_grade = dicdata.data.result;
          GetGradeList({userType:this.userRole}).then(data => {
            
            if (data.data.result) {
              this.list = data.data.result.list;
              this.fee.fee = 0;//data.data.result.fee;
              //this.count = data.data.result.fee;
              this.list.forEach(i => {
                this.certificate_grade.forEach(j => {
                  if (j.value == i.name) {
                    this.options.push({
                      value: i.id,
                      label: j.label,
                      children: [
                        {
                          value: 0,
                          label: "证书 " + i.certificateFee + "元"
                        },
                        {
                          value: 1,
                          label: "徽章 " + i.badgesFee + "元"
                        }
                      ]
                    });
                  }
                });
              });
            }
          });
        }
      });
    },
    submitForm(formName) {
      this.ruleForm.userType = this.userRole
      this.ruleForm.is_grant_test = 0;
      this.error = "";
      if (this.appType.length == 0) {
        this.error = "请选择申请等级类型";
      }
      this.ruleForm.userType = this.userRole
      this.$refs[formName].validate(valid => {
        if (valid) {
          
          this.loading = true;
          GetPaperCertificate(this.ruleForm)
            .then(data => {
              if (data.data.result.isSuccess) {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.loading = false;
                this.$router.push({ path: "/personal/gradeCertificate",query:{statusPay:1} });
                //this.back();
              }
            })
            .catch(() => {
              this.loading = false;
            });
            
        } else {
          return false;
        }
      });
    },
    handleSelect(key, keyPath) {
      //window.console.log(key, keyPath);
    },
    back() {
      this.$router.go(-1);
    },
    chooseProvince(item) {
      Getexpressfee({ area_code: item }).then(data => {
          if(data){
            this.fee.fee = data.data.result;
            this.count =  this.fee.certificateFee + this.fee.badgesFee + Number(this.fee.fee);
          }
      });
      
      GetDistrictList({ parent_id: item }).then(data => {
        this.city = data.data.result.items;
        this.ruleForm.city = this.city[0].id;
      });
    },
    chooseCity(item) {
      
      //this.fee.fee = 200;
      
      GetDistrictList({ parent_id: item }).then(data => {
        this.district = data.data.result.items;
        this.ruleForm.district = this.district[0].id;
      });
    },
    chooseDistrict() {
      this.$forceUpdate();
    },
    groupBy(array, f) {
      var groups = {};
      array.forEach(function(o) {
        var group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map(function(group) {
        return groups[group];
      });
    },
    cascader(val) {
      this.fee.certificateFee = 0;
      this.fee.badgesFee = 0;
      this.count = this.fee.fee;
      this.ruleForm.certificateList = [];
      var certificateList = [];
      val.forEach(i => {
        certificateList.push({
          paperCertificateId: i[0],
          certificate_type: i[1]
        });
      });
      var sorted = this.groupBy(certificateList, function(item) {
        return [item.paperCertificateId];
      });
      sorted.forEach(i => {
        if (i.length > 1) {
          this.ruleForm.certificateList.push({
            paperCertificateId: i[0].paperCertificateId,
            certificate_type: "0,1"
          });
        } else {
          this.ruleForm.certificateList.push({
            paperCertificateId: i[0].paperCertificateId,
            certificate_type: String(i[0].certificate_type)
          });
        }
      });
      // 处理数据拿到想要的数据格式
      this.ruleForm.certificateList.forEach(j => {
        this.list.forEach(k => {
          if (j.paperCertificateId == k.id) {
            if (j.certificate_type.indexOf(0) != -1) {
              this.fee.certificateFee += k.certificateFee;
            }
            if (j.certificate_type.indexOf(1) != -1) {
              this.fee.badgesFee += k.badgesFee;
            }
          }
        });
      });
      
      this.count =
        parseInt(this.fee.fee) +
        parseInt(this.fee.certificateFee) +
        parseInt(this.fee.badgesFee);
    }
  }
};
</script>

<style lang="less" >
.gradeCertificateDelivery {
  width: 60%;
  h3 {
    margin: 15px 0;
    position: relative;
    .goBack {
      position: absolute;
      right: 0px;
    }
  }
  p {
    color: #ea0000;
    margin-bottom: 15px;
  }
  .submit {
    text-align: center;
  }
  .cascader {
    .el-cascader-node.in-active-path {
      font-weight: 0 !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .gradeCertificateDelivery {
    width: 100%;
  }
}
</style>
